/*
https://vuex.vuejs.org/guide/
https://markus.oberlehner.net/blog/combining-graphql-and-vuex/
https://github.com/vuejs/vuex/tree/dev/examples
*/

import { API } from "aws-amplify";
import { getQuest } from "../graphql/queries";
import { questRankings } from "../graphql/custom-queries";

const state = {
  currentPage: [],
  quest: {},
};

const getters = {};

const actions = {
  async loadPage({ commit }, scoreFilter, nextToken) {
    if (state.quest?.id == null) {
      console.error("No quest defined. Can't fetch leaderboard.");
      return;
    }
    commit("setIsLoading", true, { root: true });
    const response = await API.graphql({
      query: questRankings,
      variables: {
        questId: state.quest.id,
        sortDirection: sortDirectionForQuest(),
        score: scoreFilter,
        nextToken: nextToken,
      },
    });
    console.log(`Leaderboard page: ${JSON.stringify(response)}.`);
    for (let i = 0; i < response.data.ranksForQuestByScore.items.length; i++) {
      response.data.ranksForQuestByScore.items[i].rank = i + 1;
    }
    commit("setCurrentPage", response.data.ranksForQuestByScore.items);
    commit("setIsLoading", false, { root: true });
  },

  async loadQuest({ commit }, questId) {
    commit("setIsLoading", true, { root: true });
    let response;
    try {
      response = await API.graphql({
        query: getQuest,
        variables: {
          id: questId,
        },
      });
    } catch (error) {
      console.error(`Error fetching quest for id ${questId}. Error: ${JSON.stringify(error)}.`);
      commit("setIsLoading", false, { root: true });
      return;
    }
    commit("setQuest", response.data.getQuest);
    commit("setIsLoading", false, { root: true });
  },
};

function sortDirectionForQuest() {
  if (state.quest?.type == "CheckpointRun") {
    return "DESC";
  }
  return "ASC";
}

const mutations = {
  setQuest(state, quest) {
    state.quest = quest;
  },
  setCurrentPage(state, page) {
    state.currentPage = page;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
